export const IMAGES = {
  PABLO: '/images/pablo.png',
  JIME: '/images/jime.png',
  COUPLE: '/images/noscasamos.mp4'
}; 